import { createI18n } from 'vue-i18n'
import { CookieClass } from '@/base/class/cookie.class'
import { COOKIE_LANG } from '@/base/const/cookies.const'
import { emitter } from '@/base/event-bus'
import { Raven } from '@/base/utils/raven-compat'
import { LANGUAGES, LANGUAGES_ACTIVE_LIST } from '@/base/const/lang.const'

const supportedLanguages = LANGUAGES_ACTIVE_LIST.map((lang) => lang.toLowerCase())
const fallbackLanguage = LANGUAGES.en.toLowerCase()
const navigatorLanguage = navigator.language.split('-')[0].toLowerCase()
let appLanguage = CookieClass.getCookie(COOKIE_LANG)
  ? CookieClass.getCookie(COOKIE_LANG).toLowerCase()
  : navigatorLanguage
if (!supportedLanguages.includes(appLanguage)) {
  appLanguage = fallbackLanguage
  CookieClass.setCookie(COOKIE_LANG, appLanguage.toUpperCase())
}
export const currentLang = appLanguage

const i18n = createI18n({
  legacy: true,
  locale: currentLang,
  messages: {},
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
})

export default i18n

const languageModules = import.meta.glob('./*.json')

export function loadLanguage(lang) {
  return new Promise((resolve, reject) => {
    const loadModule = languageModules[`./${lang}.json`]

    if (!loadModule) {
      const errorMsg = `language ${lang} not found`
      Raven.captureMessage(errorMsg)
      reject(new Error(errorMsg))
      return
    }

    loadModule()
      .then((messages) => {
        i18n.global.setLocaleMessage(lang, messages.default)
        i18n.global.locale = lang
        emitter.emit('language-loaded')
        resolve()
      })
      .catch((error) => {
        const errorMsg = 'loadLanguage error'
        Raven.captureMessage(errorMsg, {
          extra: { error },
        })
        reject(new Error(errorMsg))
      })
  })
}

loadLanguage(currentLang)
  .then(() => {
    i18n.locale = currentLang
  })
  .catch((error) => {
    Raven.captureMessage('Unable to load init language', {
      extra: { error },
    })
  })
